"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var BaseRepository_1 = require("./BaseRepository");
var ConfigsRepository = /** @class */ (function (_super) {
    __extends(ConfigsRepository, _super);
    function ConfigsRepository(schemaName) {
        return _super.call(this, schemaName, 'configs') || this;
    }
    return ConfigsRepository;
}(BaseRepository_1.BaseRepository));
exports.ConfigsRepository = ConfigsRepository;
var UnitsRepository = /** @class */ (function (_super) {
    __extends(UnitsRepository, _super);
    function UnitsRepository(schemaName) {
        return _super.call(this, schemaName, 'units') || this;
    }
    return UnitsRepository;
}(BaseRepository_1.BaseRepository));
exports.UnitsRepository = UnitsRepository;
var MetricsRepository = /** @class */ (function (_super) {
    __extends(MetricsRepository, _super);
    function MetricsRepository(schemaName) {
        return _super.call(this, schemaName, 'metrics') || this;
    }
    return MetricsRepository;
}(BaseRepository_1.BaseRepository));
exports.MetricsRepository = MetricsRepository;
var MetricSetsRepository = /** @class */ (function (_super) {
    __extends(MetricSetsRepository, _super);
    function MetricSetsRepository(schemaName) {
        return _super.call(this, schemaName, 'metric_sets') || this;
    }
    return MetricSetsRepository;
}(BaseRepository_1.BaseRepository));
exports.MetricSetsRepository = MetricSetsRepository;
var LocationsRepository = /** @class */ (function (_super) {
    __extends(LocationsRepository, _super);
    function LocationsRepository(schemaName) {
        return _super.call(this, schemaName, 'locations') || this;
    }
    return LocationsRepository;
}(BaseRepository_1.BaseRepository));
exports.LocationsRepository = LocationsRepository;
var PeriodsRepository = /** @class */ (function (_super) {
    __extends(PeriodsRepository, _super);
    function PeriodsRepository(schemaName) {
        var _this = _super.call(this, schemaName, 'periods') || this;
        _this._processTextResponse = function (response) {
            var processed = response.replace(/"id":(\d+)/g, '"id":"$1"');
            return processed;
        };
        return _this;
    }
    PeriodsRepository.prototype._sort = function (es) {
        es.sort(function (e1, e2) {
            if (e1.start_time !== e2.start_time) {
                return e1.start_time.localeCompare(e2.start_time);
            }
            return e2.period_type - e1.period_type;
        });
    };
    return PeriodsRepository;
}(BaseRepository_1.BaseRepository));
exports.PeriodsRepository = PeriodsRepository;
var DashboardTopicsRepository = /** @class */ (function (_super) {
    __extends(DashboardTopicsRepository, _super);
    function DashboardTopicsRepository(schemaName) {
        return _super.call(this, schemaName, 'dashboard_topics') || this;
    }
    return DashboardTopicsRepository;
}(BaseRepository_1.BaseRepository));
exports.DashboardTopicsRepository = DashboardTopicsRepository;
var DashboardsRepository = /** @class */ (function (_super) {
    __extends(DashboardsRepository, _super);
    function DashboardsRepository(schemaName) {
        return _super.call(this, schemaName, 'dashboards') || this;
    }
    DashboardsRepository.prototype._sort = function (es) {
        es.sort(function (e1, e2) {
            if (e1.srt !== e2.srt) {
                return e1.srt - e2.srt;
            }
            return e1.id - e2.id;
        });
    };
    return DashboardsRepository;
}(BaseRepository_1.BaseRepository));
exports.DashboardsRepository = DashboardsRepository;
var DashletsRepository = /** @class */ (function (_super) {
    __extends(DashletsRepository, _super);
    function DashletsRepository(schemaName) {
        return _super.call(this, schemaName, 'dashlets') || this;
    }
    DashletsRepository.prototype._sort = function (es) {
        es.sort(function (e1, e2) {
            return e1.id - e2.id;
        });
    };
    return DashletsRepository;
}(BaseRepository_1.BaseRepository));
exports.DashletsRepository = DashletsRepository;
var AttachmentsRepository = /** @class */ (function (_super) {
    __extends(AttachmentsRepository, _super);
    function AttachmentsRepository(schemaName) {
        return _super.call(this, schemaName, 'attachments') || this;
    }
    return AttachmentsRepository;
}(BaseRepository_1.BaseRepository));
exports.AttachmentsRepository = AttachmentsRepository;
var ResourcesRepository = /** @class */ (function (_super) {
    __extends(ResourcesRepository, _super);
    function ResourcesRepository(schemaName) {
        return _super.call(this, schemaName, 'resources') || this;
    }
    return ResourcesRepository;
}(BaseRepository_1.BaseRepository));
exports.ResourcesRepository = ResourcesRepository;
var TextDataRepository = /** @class */ (function (_super) {
    __extends(TextDataRepository, _super);
    function TextDataRepository(schemaName) {
        var _this = _super.call(this, schemaName, 'text_data') || this;
        _this._processTextResponse = function (response) {
            var processed = response.replace(/"period_id":(\d+)/g, '"period_id":"$1"');
            return processed;
        };
        return _this;
    }
    return TextDataRepository;
}(BaseRepository_1.BaseRepository));
exports.TextDataRepository = TextDataRepository;
